import { IFormField} from "../web-form.objects"
import { JsonItem, PickListItem } from "../../../entities/pick-list/pick-list.entities";
import { TableRenderer, TableRenderType, RenderGroup } from "../../edit-table/table-renderer";
import _ from "lodash";

export class NestedFormInputOptions {
    noItemDisplay: string; // What is shown when nothing is added
    defaultItem: any; // base item used for adding new 
    titleRenderGroups: RenderGroup[]; // Used as title for added items
    formFields: IFormField[]; // Form Fields for item

    constructor(noItemDisplay: string, defaultItem: any, titleRenderGroups: RenderGroup[], formFields: IFormField[]) {
        this.noItemDisplay = noItemDisplay;
        this.defaultItem = defaultItem;
        this.titleRenderGroups = titleRenderGroups; 
        this.formFields = formFields;
    }
}

export class NestedFormInputField implements IFormField {
    fieldId: string; 
    displayName: string; 
    description: string;
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    initialVal: any;

    options: NestedFormInputOptions;

    pickLists: JsonItem[];
    storedValues: any[];
    addedItemGallery: JQuery<HTMLElement>;
    addItemBtn: JQuery<HTMLElement>;
    errorTextBlock: JQuery<HTMLElement>;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: NestedFormInputOptions) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.options = options;

        this.defaultVal = [];
        this.initialVal = [];

        this.storedValues = [];
        this.pickLists = [];
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let nestedFormFields = "";
        this.options.formFields.forEach(field => {
            let fieldHtml = field.generateHtml();
            nestedFormFields += fieldHtml;
        });

        let html = `
            <label class="label-title ${requiredClass}">${this.displayName}</label>
            ${this.description != "" ? `<p class='form-text'>${this.description}</p>` : ``}
            <div id="${this.fieldId}" class="nested-form-container">
                <div class="nested-form-gallery">

                </div>
                <hr class="dark-break" />
                <div class="nested-form-section">
                    ${nestedFormFields}
                    <div class="mt-3">
                        <button class="butn small nested-form-add-btn"><span>+ Add</span></button>
                    </div>
                    <p class="d-none error-msg"></p>
                </div>
            </div>
        `;

        return html;
    }

    initialize() {
        let formBlock = $(`#${this.fieldId}`);
        this.addedItemGallery = formBlock.find(".nested-form-gallery");
        this.addItemBtn = formBlock.find(".nested-form-add-btn");
        this.errorTextBlock = formBlock.find(".error-msg");

        this.options.formFields.forEach(field => field.initialize());

        this.initializeAddBtn();
        this.drawGallery();
    }

    prepopulate(items: any[]): void {
        this.initialVal = this.defaultVal;

        let testArr: any[] = []; 
        items.forEach(item => {
            let itemArr = _.get(item, this.propertyName);
            testArr.push(...itemArr);
        });

        let sharedItems: any[] = [];
        for (let i = 0; i < testArr.length; i++) {
            let testCase = testArr[i];
            let sharedItem = items.every(item => {
                let itemArr = <any[]>_.get(item, this.propertyName);
                let checkExists = itemArr.some(x => {
                    let isMatch = true;
                    this.options.formFields.forEach(field => {
                        let checkSame = field.compareItems(testCase, x);
                        if (!checkSame) {
                            isMatch = false;
                            return isMatch;
                        }
                    });
                    return isMatch;
                });
                return checkExists;
            });
            if (sharedItem) {
                let newItem = _.cloneDeep(this.options.defaultItem);
                this.options.formFields.forEach(field => {
                    let newVal = _.get(testCase, field.propertyName);
                    _.set(newItem, field.propertyName, newVal);
                })
                sharedItems.push(newItem);
            }
        }

        this.initialVal = [...sharedItems];
        this.storedValues = [...sharedItems];

        this.drawGallery();
    }

    updateItem(item: any): any {
        let addArr: any[] = [];
        let removeArr: any[] = [];

        let initialArr = <any[]>this.initialVal;

        initialArr.forEach(x1 => {
            let checkExists = this.storedValues.some(x2 => {
                let isMatch = true;
                this.options.formFields.forEach(field => {
                    let checkSame = field.compareItems(x1, x2);
                    if (!checkSame) {
                        isMatch = false;
                        return isMatch;
                    }
                });
                return isMatch;
            });
            if (!checkExists) {
                removeArr.push(x1);
            }
        });

        this.storedValues.forEach(y1 => {
            let checkExists = initialArr.some(y2 => {
                let isMatch = true;
                this.options.formFields.forEach(field => {
                    let checkSame = field.compareItems(y1, y2);
                    if (!checkSame) {
                        isMatch = false;
                        return isMatch;
                    }
                })
                return isMatch;
            });
            if (!checkExists) {
                addArr.push(y1);
            }
        });

        let updatedItem = _.cloneDeep(item);

        if (addArr.length > 0 || removeArr.length > 0) {
            let targetArray = <any[]>_.get(updatedItem, this.propertyName);
            // Remove Items
            removeArr.forEach(rm => {
                let foundIndex = targetArray.findIndex(x => {
                    let isMatch = true;
                    this.options.formFields.forEach(field => {
                        let checkSame = field.compareItems(rm, x);
                        if (!checkSame) {
                            isMatch = false;
                            return false;
                        }
                    });
                    return isMatch;
                });
                if (foundIndex >= 0) {
                    targetArray.splice(foundIndex, 1);
                }
            });

            // Add Items
            addArr.forEach(add => {
                let foundIndex = targetArray.findIndex(x => {
                    let isMatch = true;
                    this.options.formFields.forEach(field => {
                        let checkSame = field.compareItems(add, x);
                        if (!checkSame) {
                            isMatch = false;
                            return false;
                        }
                    });
                    return isMatch;
                });
                if (foundIndex < 0) {
                    targetArray.push(add);
                }
            });

            _.set(updatedItem, this.propertyName, targetArray);
        }
            
        return updatedItem;
    }


    private drawGallery(triggerChange: boolean = false) {
        this.addedItemGallery.empty();
        let content = "";
        if (this.storedValues.length == 0) {
            content = `<div class="nested-form-placeholder">${this.options.noItemDisplay}</div>`;
            this.addedItemGallery.append(content);
        }
        else {
            for (let i = 0; i < this.storedValues.length; i++) {
                let item = this.storedValues[i];
                let title = this.getDisplayTitle(item);              

                if (!title) {
                    title = `Item ${i + 1}`;
                }

                let card = `
                    <div class="nested-form-card">
                        <div class="nested-form-card-header">
                            <div class="col">
                                <div class="nested-form-card-title">${title}</div>
                            </div>
                            <div class="col-auto">
                                <button class="butn small nested-form-delete-btn" data-item-index="${i}"><span><i class="fa-solid fa-trash-can"></i></span></button>
                            </div>
                        </div>
                    </div>
                `

                content += card;
            }

            let galleryHtml = `
                <div id="${this.fieldId}-gallery-container">
                    ${content}
                </div>
            `
            this.addedItemGallery.append(galleryHtml);
            let nestedForm = this;
            this.addedItemGallery.find(".nested-form-delete-btn").on("click", function () {
                let targetIndex = $(this).data("itemIndex");
                let index: number = parseInt(targetIndex);
                let foundItem = nestedForm.storedValues[index];
                if (foundItem) {
                    nestedForm.storedValues.splice(index, 1);
                    nestedForm.drawGallery(true);
                }
            })
        }

        this.refreshForm();
        if (triggerChange) {
            $(`#${this.fieldId}`).trigger("form-field-change")
        }
    }

    private getDisplayTitle(item: any) {
        let renderer = new TableRenderer(this.pickLists);
        let title = "";
        for (let j = 0; j < this.options.titleRenderGroups.length; j++) {
            let group = this.options.titleRenderGroups[j];
            let prop = _.get(item, group.propertyName);
            let display = "";
            if (group.renderType == TableRenderType.Date) {
                display = renderer.renderDate(prop);
            }
            else if (group.renderType == TableRenderType.YesNo) {
                display = renderer.renderYesNo(prop);
            }
            else if (group.pickListId) {
                display = renderer.renderDisplay(prop, group.renderType, group.pickListId);
            }
            else {
                display = prop;
            }

            if (j == 1) {
                title += " ("
            }
            else if (j > 1) {
                title += ", ";
            }
            title += display;

            if (j > 0 && j == this.options.titleRenderGroups.length - 1) {
                title += ")";
            }
        }

        return title;
    }

    // Remove selected items from dropdown
    private refreshForm() {
        this.options.formFields.forEach(field => {
            field.prepopulate([this.options.defaultItem]); // Prepopulate with default item
            field.resetValidDisplay();
        })
    }

    private initializeAddBtn() {
        this.addItemBtn.off().on('click', () => {
            let isValid = true;
            let invalidFields: IFormField[] = [];
            this.options.formFields.forEach(field => {
                field.resetValidDisplay();
                let fieldValid = field.checkValid();
                if (!fieldValid) {
                    isValid = false;
                    invalidFields.push(field);
                }
                field.displayValid(fieldValid);
            });

            if (!isValid) {
                this.setErrorText("Please complete all required fields.")
                return;
            }

            let newItem = _.cloneDeep(this.options.defaultItem);
            this.options.formFields.forEach(field => {
                newItem = field.updateItem(newItem);
            });

            // Check if item already exists
            let isDuplicate = false;
            this.storedValues.forEach(item => {
                let entryExists = this.options.formFields.every(field => {
                    let checkSame = field.compareItems(newItem, item);
                    return checkSame;               
                });
                if (entryExists) {
                    isDuplicate = true;
                }
            });

            if (isDuplicate) {
                this.setErrorText("An entry with these properties already exists for this item.")
                return;
            }

            if (isValid && !isDuplicate) {
                this.storedValues.push(newItem);
                this.drawGallery(true);
                this.refreshForm();
                this.setErrorText();
            }
        })
    }

    private setErrorText(errorText: string = null) {
        if (errorText == null) {
            this.errorTextBlock.text('');
            this.errorTextBlock.addClass('d-none');
            this.resetValidDisplay();
        }
        else {
            this.errorTextBlock.text(errorText);
            this.errorTextBlock.removeClass('d-none');
            this.displayValid(false);
        }
    }

    setOptions(pickLists: JsonItem[]) {
        this.pickLists = pickLists;
        this.options.formFields.forEach(field => field.setOptions(pickLists));
    }

    getValue(): any {
        let val = this.initialVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.storedValues;
        }

        return val;
    }

    setValue(formData: any) {
        this.storedValues = [];
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            if (formVal) {
                this.storedValues = formVal;
            }
        }
        this.drawGallery();
    }

    checkValid(): boolean {
        if (this.isRequired) {
            if (this.storedValues.length == 0) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let currentVal = <any[]>this.storedValues;
        let initialVal = <any[]>this.initialVal;

        if (currentVal.length != initialVal.length) {
            return true;
        }

        // initial and current are the same length
        for (let i = 0; i < currentVal.length; i++) {
            let y1 = currentVal[i];
            let isFound = initialVal.some(y2 => {
                for (let j = 0; j < this.options.formFields.length; j++) {
                    let field = this.options.formFields[j];
                    let checkSame = field.compareItems(y1, y2);
                    if (!checkSame) {
                        return false;
                    }
                }
                return true;
            });
            if (!isFound) {
                return true;
            }
        }
        
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            return;
        }
        else {
            return;
        }
    }

    resetValidDisplay() {
        return;
    }

    private getDisplayVal(valArr: any[]): string {
        let listContent: string = "";

        valArr.forEach(val => {
            let displayTitle = this.getDisplayTitle(val);
            listContent += `<li>${displayTitle}</li>`;
        })

        return `<ul class="pl-2 mb-0">${listContent}</ul>`;
    }

    private getAddedDisplay(newItem: any, prevItem: any): string {
        // Updated List
        let x1Arr = <any[]>_.get(newItem, this.propertyName);
        // Current List
        let x2Arr = <any[]>_.get(prevItem, this.propertyName);

        let addedArr: any[] = [];
        x1Arr.forEach(x1 => {
            // if can't find matching item in current list, add it
            if (!x2Arr.some(x2 => {
                let isMatch = true;
                this.options.formFields.forEach(field => {
                    let checkSame = field.compareItems(x1, x2);
                    if (!checkSame) {
                        isMatch = false;
                        return isMatch;
                    }
                })
                return isMatch
            })) {
                addedArr.push(x1);
            }
        });

        if (addedArr.length == 0) {
            return "";
        }
        let addedDisplay = this.getDisplayVal(addedArr);
        return addedDisplay;
    }

    private getRemovedDisplay(newItem: any, prevItem: any): string {
        // Updated List
        let x1Arr = <any[]>_.get(newItem, this.propertyName);
        // Current List
        let x2Arr = <any[]>_.get(prevItem, this.propertyName);

        let rmArr: any[] = [];
        x2Arr.forEach(x2 => {
            // if can't find matching item in updated list, remove it
            if (!x1Arr.some(x1 => {
                let isMatch = true;
                this.options.formFields.forEach(field => {
                    let checkSame = field.compareItems(x1, x2);
                    if (!checkSame) {
                        isMatch = false;
                        return isMatch;
                    }
                })
                return isMatch
            })) {
                rmArr.push(x2);
            }
        });

        if (rmArr.length == 0) {
            return "";
        }
        let rmDisplay = this.getDisplayVal(rmArr);
        return rmDisplay;
    }

    compareItems(item1: any, item2: any): boolean {
        let x1 = <any[]>_.get(item1, this.propertyName);
        let x2 = <any[]>_.get(item2, this.propertyName);

        if (x1.length != x2.length) {
            return false;
        }
        else {
            // Same length
            for (let i = 0; i < x1.length; i++) {
                let y1 = x1[i];
                let isFound = x2.some(y2 => {
                    for (let j = 0; j < this.options.formFields.length; j++) {
                        let field = this.options.formFields[j];
                        let checkSame = field.compareItems(y1, y2);
                        if (!checkSame) {
                            return false;
                        }
                    }
                    return true;
                });
                if (!isFound) {
                    return false;
                }
            }
        }

        return true;
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let isChanged = false;

        if (prevItem == undefined) {
            isChanged = true;
        }
        else {
            isChanged = !this.compareItems(newItem, prevItem);
        }

        if (!isChanged) {
            return "";
        }

        let changeContent = "";

        let addedDisplay = this.getAddedDisplay(newItem, prevItem);
        if (addedDisplay) {
            let newDisplay = `
                    <div class="new-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-plus new-change-icon"></i>
                        </div>
                        <div class="col">
                            ${addedDisplay}
                        </div>
                    </div>
                `;
            changeContent = newDisplay;
        }

        let removeDisplay = this.getRemovedDisplay(newItem, prevItem);
        if (removeDisplay) {
            let prevDisplay = `
                    <div class="delete-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-trash-can delete-change-icon"></i>
                        </div>
                        <div class="col">
                            ${removeDisplay}
                        </div>
                    </div>
                `;
            changeContent += prevDisplay;
        }

        let html = `
                <div class="change-content-block">
                    <div class="change-content-label">
                        ${this.displayName}
                    </div>
                    ${changeContent}
                </div>
            `;

        return html;
    }
}

